module.exports = __webpack_public_path__ + "static/media/tågvagn-min.83a27b01.png";